import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { CampaignPage } from './pages/CampaignPage';
import { SocialPage } from './pages/SocialPage';
export function App() {
  return <Routes data-id="element-0">
      <Route path="/" element={<Layout data-id="element-2" />} data-id="element-1">
        <Route index element={<Navigate to="/campaign" replace data-id="element-4" />} data-id="element-3" />
        <Route path="campaign" element={<CampaignPage data-id="element-6" />} data-id="element-5" />
        <Route path="social" element={<SocialPage data-id="element-8" />} data-id="element-7" />
      </Route>
    </Routes>;
}